export default "__VITE_ASSET__BzsXlEK9__"